import { render, staticRenderFns } from "./paperpile-left-sidebar.html?vue&type=template&id=760b840c&scoped=true&external"
import script from "./paperpile-left-sidebar.js?vue&type=script&lang=js&external"
export * from "./paperpile-left-sidebar.js?vue&type=script&lang=js&external"
import style0 from "./paperpile-left-sidebar.scss?vue&type=style&index=0&id=760b840c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760b840c",
  null
  
)

export default component.exports